import axios from 'axios';
// @ts-ignore
import { FetchCountryName } from '../Utils/CountryUtility';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const dietary = [
  {
    id: 'has_meat',
    label: 'Has Meat',
    emoji: '🥩',
    explanation: 'Contains any type of meat such as beef, lamb, pork, or poultry',
  },
  {
    id: 'has_seafood',
    label: 'Has Seafood',
    emoji: '🦐',
    explanation: 'Includes fish, shellfish, or other ocean-based ingredients',
  },
  {
    id: 'has_dairy',
    label: 'Has Dairy',
    emoji: '🧀',
    explanation: 'Contains milk, cheese, butter, or other dairy products',
  },
  {
    id: 'has_eggs',
    label: 'Has Eggs',
    emoji: '🥚',
    explanation: 'Includes eggs in any form, including baked goods or sauces',
  },
  {
    id: 'has_fruits',
    label: 'Has Fruits',
    emoji: '🍓',
    explanation: 'Contains fresh, dried, or cooked fruits',
  },
  {
    id: 'has_vegetables',
    label: 'Has Vegetables',
    emoji: '🥦',
    explanation: 'Includes leafy greens, root vegetables, or other plant-based produce',
  },
  {
    id: 'has_grains',
    label: 'Has Grains',
    emoji: '🌾',
    explanation: 'Contains wheat, rice, corn, oats, or other grain-based ingredients',
  },
  {
    id: 'has_nuts_and_seeds',
    label: 'Has Nuts or Seeds',
    emoji: '🥜',
    explanation: 'Includes peanuts, tree nuts, seeds, or nut-based oils',
  },
  {
    id: 'has_fungi',
    label: 'Has Fungi',
    emoji: '🍄',
    explanation: 'Contains mushrooms or other edible fungi',
  },
];

export const foodTypes = [
  {
    id: 'Pastry',
    label: 'Pastry',
    emoji: '🥐',
    explanation: 'Baked goods, often sweet or savory, typically made with flour and butter. Examples: croissants, danishes, empanadas.',
  },
  {
    id: 'Beverage',
    label: 'Beverage',
    emoji: '🥤',
    explanation: 'Liquid refreshments, both hot and cold. Examples: coffee, tea, juice, cocktails.',
  },
  {
    id: 'Dessert',
    label: 'Dessert',
    emoji: '🍰',
    explanation: 'Sweet dishes typically served after the main course. Examples: cake, gelato, crème brûlée.',
  },
  {
    id: 'SideDishOrAppetizer',
    label: 'Side Dish or Appetizer',
    emoji: '🥗',
    explanation: 'Dishes meant to complement the main course. Examples: mashed potatoes, salads, steamed vegetables, garlic bread.',
  },
  {
    id: 'MainDish',
    label: 'Main Dish',
    emoji: '🍛',
    explanation: 'The central dish of a meal, typically protein-based or substantial. Examples: steak, lasagna, tofu curry.',
  },
];

interface HandleDuplicateFoodPostsProps {
  post: DuplicateFoodPost;
  toggleButtonRef: React.MutableRefObject<HTMLDivElement | null>;
  openPanel: number | null;
  setOpenPanel: React.Dispatch<React.SetStateAction<number | null>>;
}

interface CountryEntry {
  iso: string;
  id: number;
}

interface DuplicateFoodPost {
  representative_id: number;
  countries: CountryEntry[];
}

export const HandleDuplicateFoodPosts = ({ post, toggleButtonRef, openPanel, setOpenPanel }: HandleDuplicateFoodPostsProps) => {
  const navigate = useNavigate();
  const [resolvedNames, setResolvedNames] = useState<Record<string, string>>({});

  useEffect(() => {
    const resolveNames = async () => {
      if (openPanel === post.representative_id && post.countries.length > 0) {
        const names: Record<string, string> = {};

        for (const entry of post.countries) {
          const name = await FetchCountryName(entry.iso);
          names[entry.iso] = name;
        }
        setResolvedNames(names);
      }
    };

    resolveNames();
  }, [openPanel, post]);

  return (
    <div>
      {post.countries.length > 1 && (
        <div
          className="duplicate-indicator"
          ref={toggleButtonRef}
          onClick={(e) => {
            e.stopPropagation();
            setOpenPanel((prev) => (prev === post.representative_id ? null : post.representative_id));
          }}
        >
          🔁 View in other countries
        </div>
      )}

      {openPanel === post.representative_id && (
        <div className="slide-in-panel">
          <h2>Also appears in:</h2>
          <ul>
            {post.countries.map((entry) => (
              <li key={entry.iso}>
                <button
                  onClick={async () => {
                    try {
                      const countryName = await FetchCountryName(entry.iso);
                      const pageResponse = await axios.get(`${backendUrl}/worlddata/food/get-cursor-for-item/${entry.id}/9/?iso=${entry.iso}`);
                      const cursor = pageResponse.data.cursor;
                      const cursorToken = pageResponse.data.cursor_token || '';
                      navigate(`/traveltopics/${countryName}/topics/food`, {
                        state: {
                          selectedItemId: entry.id,
                          selectedItemCursor: cursor,
                          selectedItemCursorToken: cursorToken,
                          category: '',
                        },
                      });
                    } catch (error) {
                      console.error('Error navigating to sightseeing item from latest page through a representative item:', error);
                    }
                  }}
                >
                  {resolvedNames[entry.iso] || entry.iso}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
